export const uhvEquipments = [
  {
    name: "STREAM SPM system",
    overallImage: "/equipments/stream.jpg",
    parts: [
      {
        name: "Tribus SPM head",
        description: "The Tribus SPM head from ScientaOmicron can achieve atomic resolution image from 10 K to 400 K with a nanometer to micrometer scale. By using a TVS sample plate, imaging at a given temperature is possible.",
        image: "/equipments/stream-tribus.jpg",
      },
      {
        name: "4-axis manipulator",
        description: "The 4-axis manipulator from PreVac is equipped with liquid nitrogen cooling and e-beam heating that can reach 1000 C.",
        image: "/equipments/stream-manipulator.jpg",
      },
      {
        name: "EFM3 evaporator",
        description: "Focus EFM3 evaporator is an e-beam evaporator that is used for ultra-pure physical vapor deposition. Materials can be mounted as a rod or in a crucible. The 0-2kV controller allows for deposition of high melting point materials. The two evaporators shares a target focus, which is used as a single- or dual-deposition.",
        image: "/equipments/stream-efm3.jpg",
      },
      {
        name: "microCMA Auger electron spectroscopy",
        description: "The microCMA from RBD instrument is a neat and easy use to detect elements, especially light elements, on a sample surface.",
        image: "/equipments/microCMA.jpg",
        manufactoryLogo: "/logos/rbd-logo.png",
        manufactoryUrl:"https://www.rbdinstruments.com/products/microcma.html"
      },
      {
        name: "IG2 sputter ion source",
        description: "The IG2 sputter ion source is used to clean sample through back-filled sputtering.",
        image: "/equipments/IG2.jpg",
        manufactoryLogo: "/logos/rbd-logo.png",
        manufactoryUrl:"https://www.rbdinstruments.com/products/ig2.html"
      },
      {
        name: "SRS RGA mass spectrometer",
        description: "The SRS RGA mass spectrometer is able to detect 1-100 amu and is used mostly for background gas and leak detection.",
        image: "/equipments/srsRGA.jpg",
      },
      {
        name: "direct dosing line",
        description: "The direct dosing line can introduce gases directly to the sample for sample treatment. The enhancement factor is estimated to be 100.",
        image: "/equipments/stream-dosing.jpg",
      },
      {
        name: "SXM controller",
        description: "The SXM controller from ScientaOmicron includes full SPM control electronics including PLL and Lock-In amplifier.",
        image: "/equipments/SXM.jpg",
      },
      {
        name: "Power rack for STREAM SPM",
        description: "The power rack provides power to controllers for equipment on the STREAM system and has a integrated bake-out unit.",
        image: "/equipments/stream-powerrack.jpg",
      },
    ],
  },
  {
    name: "ScientaOmicron VT-SPM system",
    overallImage: "/equipments/VT.jpg",
    parts: [
      {
        name: "LEED/AES",
        description: "The LEED and AES two-in-one from OCI Vacuum Microengineering has the capability to collect LEED pattern data via a CCD camera and detect surface element using the add-on AES component.",
        image: "/equipments/Leed-aus.jpg",
      },
      {
        name: "VT SPM",
        description: "The VT SPM from ScientaOmicron is used to detect atomic structures on well-defined surfaces at room temperature or liquid nitrogen temperature. The STM is controlled by MATRIX controller.",
        image: "/equipments/vt-head.jpg",
      },
      {
        name: "4-axis manipulator",
        description: "The 4-axis from ScientaOmicron has an integrated sample stage for resistive or direct annealing.",
        image: "/equipments/vt-manipulator.jpg",
      },
      {
        name: "PrismaPro RGA mass spectrometer",
        description: "The PrismaPro RGA mass spectrometer from Pfeiffer Vacuum has a detection range of 1-200 amu.",
        image: "/equipments/prismaRGA.jpg",
      },
      {
        name: "Retractable EFM3 evaporator",
        description: "The EFM3 evaporator from Focus is mounted in a retractable bellow to allow for easy materials loading/unloading without the need to vent the preparation chamber.",
        image: "/equipments/retractable-efm3.jpg",
      },
      {
        name: "Co-focused EFM3 evaporator",
        description: "The EFM3 evaporator from Focus is mounted in the same preparation chamber to allow for co-evaporation on a sample simultaneously.",
        image: "/equipments/VT-evaporator2.jpg",
      },
      {
        name: "Ion source IS40",
        description: "The Prevac sputter gun is fully automated and can ionize inert gases up to 5keV.",
        image: "/equipments/Vt-sputter.jpg",
      },
      {
        name: "microCMA Auger electron spectroscopy",
        description: "The microCMA from RBD instrument is a neat and easy use to detect elements, especially light elements, on a sample surface.",
        image: "/equipments/VT-microCMA.jpg",
        manufactoryLogo: "/logos/rbd-logo.png",
        manufactoryUrl:"https://www.rbdinstruments.com/products/microcma.html"
      },
      {
        name: "Power rack for the VT-SPM system",
        description: "The power rack provides power to controllers for equipment on the STREAM system and has a integrated touch screen control and a bake-out unit.",
        image: "/equipments/vt-power rack.jpg",
      },
    ],
  },
  {
    name: "Wall-E Testing Station (Thank Dr. Roger Carr for donating the chamber to us.)",
    overallImage: "/equipments/wall-E.jpg",
    parts: []
  }
];


export const nanoEquipments = [
  {
    name: "ASAP 2020",
    description: "The ASAP 2020 from micromeritics is fully automated. It is an essential tool for providing surface area and porosity measurements on a wide variety of materials.",
    image: "/equipments/ASAP.jpg",
  },
  {
    name: "Home-built synthesis apparatus",
    description: "The home-built apparatus is used for synthesis nanomaterials. Samples can be pretreated with reducing or oxidizing gas up to 300 C. The desiccator generate an air-tight and dry environment. By switching the exhaust line to a vacuum pump, the apparatus is switched to an equivalent vacuum oven. ",
    image: "/equipments/apparatus.jpg",
  },
  {
    name: "Bench top glove box",
    description: "The bench top glove box is used to treat samples with limited contact to oxygen. The glove box is flushed and purged with pure nitrogen gas. An oxygen concentration monitor is used to monitor the oxygen level in the main chamber. A separate load lock is used to loading samples without the need to vent the whole system. We thank Dr. Kirk Schanze for donating this piece of equipment to us.",
    image: "/equipments/glove-box.jpg",
  }
];

export const labTools = [
  {
    name: "Soldering station",
    description: "This is a 2 in 1 hot air rework and soldering iron station with °F /°C, cool/hot air conversion, digital temperature correction and sleep function.",
    image: "/equipments/soldering.jpg",
  },
  {
    name: "Local air filter",
    description: "The local air filter is used with soldering to remove hazardous gases and particles in the area.",
    image: "/equipments/soldering-vent.jpg",
  },
  {
    name: "LG7 ozone generator",
    description: "The LG7 ozone generator convenient generates ozone. It comes with a flow rate control and ozone concentration monitor. The exhaust gas tube removes all hazardous ozone, and the remaining oxygen can be directly released to a workspace.",
    image: "/equipments/ozone.jpg",
  },
  {
    name: "Digital ultrasonic cleaner",
    description: "The sonicator has both temperature and time control.",
    image: "/equipments/sonicator.jpg",
  },
  {
    name: "Oscilloscope",
    description: "The oscilloscope has a dual channel display and is used for monitoring tunneling current.",
    image: "/equipments/oscilloscope.jpg",
  },
  {
    name: "Lauda Alpha RA8 Chiller",
    description: "The chiller is used with evaporators for water cooling.",
    image: "/equipments/chiller.jpg",
  },
  {
    name: "SRS SR860 Lock-In Amplifier",
    description: "The lock-in amplifier is used to couple with STM for collecting dI/dV mapping.",
    image: "/equipments/SR860.jpg",
  },
];

export const userFacilities = [
  {
    img: "logos/kamc.jpg",
    link: "https://research.utsa.edu/cores/KAMC/",
  },
  {
    img: "logos/bnl-logo-2021.jpg",
    link: "https://www.bnl.gov/world/",
  }
];